import React from 'react';

import PreChatHeader from '../ui/PreChatHeader';
import PreChatContainer from '../ui/PreChatContainer';
import InfoCardGrid from '../ui/InfoCardGrid';
import InfoCard from '../ui/InfoCard';
import BulletList from '../ui/BulletList';

const AppealLetters: React.FC = () => {
    const analyzeItems = [
        'Denial reason assessment',
        'Policy and coverage analysis',
        'Evidence gathering recommendations',
        'Appeal letter structure and content',
        'Professional language and tone'
    ];

    const denialReasons = [
        '"Medical necessity not established"',
        '"Service not covered under policy"',
        '"Prior authorization required"',
        '"Out of network provider"',
        '"Documentation insufficient"'
    ];

    return (
        <PreChatContainer>
            <PreChatHeader
                icon="/assets/appeal-letters.png"
                iconAlt="Appeal Letters"
                title="Appeal Letters"
                description="I'll help you generate professional appeal letters for denied claims."
                instructions="Please attach your denial documentation using the paperclip icon in the chatbox below or drag & drop it here."
            />

            <InfoCardGrid>
                <InfoCard title="I will analyze the following:">
                    <BulletList items={analyzeItems} />
                </InfoCard>
                <InfoCard title="Examples of denial reasons:">
                    <BulletList items={denialReasons} />
                </InfoCard>
            </InfoCardGrid>
        </PreChatContainer>
    );
};

export default AppealLetters;



